import React from 'react';

export interface DescriptionMetaSeparatorProps {}

const DescriptionMetaSeparator: React.FC<
  DescriptionMetaSeparatorProps
> = () => <>{' • '}</>;

export default DescriptionMetaSeparator;
